import React from "react";
import { useSelector } from "services/redux/rootReducer";
import useCurrentTableState from "../hooks/useCurrentTableState";
import { SpacerCell, StyledRow } from "../row/row.styled";
import HeaderCell from "./headerCell";

const HeaderRow = () => {
    const { readOnlyMode } = useSelector((state) => state.subProducts);

    const { columns, rows } = useCurrentTableState();

    const displayedCells = columns.map((propertyColumn, idx) => (
        <HeaderCell
            key={propertyColumn.accessor}
            propertyColumn={propertyColumn}
            idx={idx}
        />
    ));

    return (
        <StyledRow isHeader>
            {rows.length > 0 && (
                <SpacerCell width={readOnlyMode ? "3.6rem" : "12.6rem"} />
            )}
            {displayedCells}
        </StyledRow>
    );
};

export default HeaderRow;
